import { AllocationRule, AllocationRuleStatus, ResultVia } from './types';

export const getStatusColor = (status: AllocationRuleStatus | boolean) => {
  const isActive = typeof status === 'boolean' ? status : status === 'active';
  return isActive
    ? 'bg-green-50/80 text-green-700 border border-green-200/60'
    : 'bg-gray-50/80 text-gray-600 border border-gray-200/60';
};

export const getResultViaVariant = (resultVia: ResultVia): 'partner' | 'internal' | 'courier' | 'warehouse' | 'default' => {
  const mapping: Record<ResultVia, 'partner' | 'internal' | 'courier' | 'warehouse' | 'default'> = {
    'Partner': 'partner',
    'Internal': 'internal',
    'Courier': 'courier',
    'InternalWarehouse': 'warehouse',
  };
  return mapping[resultVia] || 'default';
};

export const getPriorityLabel = (priority: number): 'high' | 'medium' | 'low' => {
  if (priority >= 15) return 'high';
  if (priority >= 8) return 'medium';
  return 'low';
};

export const truncateText = (text: string | undefined | null, maxLength: number = 50): string => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

export const formatDateTime = (dateTimeStr: string | undefined | null): string => {
  if (!dateTimeStr) return 'N/A';
  try {
    const date = new Date(dateTimeStr);
    if (isNaN(date.getTime())) return dateTimeStr;
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  } catch {
    return dateTimeStr;
  }
};

export const formatDate = (dateTimeStr: string | undefined | null): string => {
  if (!dateTimeStr) return 'N/A';
  try {
    const date = new Date(dateTimeStr);
    if (isNaN(date.getTime())) return dateTimeStr;
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return dateTimeStr;
  }
};

export const shouldShowTooltip = (text: string | undefined | null): boolean => {
  return Boolean(text && text.trim().length > 0);
};

export const truncateToastText = (text: string | undefined | null, maxLength: number = 12): string => {
  if (!text) return text || '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

export const getErrorMessage = (error: any, fallback: string): string => {
  return error?.graphQLErrors?.[0]?.message || error?.message || fallback;
};

